/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const FloorIcon = createIcon({
  displayName: "FloorIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M3 13H6.6875V10.2292H8.83333V7.45833H10.9792V4.66667H13V3H9.3125V5.77083H7.16667V8.54167H5.02083V11.3333H3V13ZM2.16667 15.5C1.70833 15.5 1.31597 15.3368 0.989583 15.0104C0.663194 14.684 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663194 1.31597 0.989583 0.989583C1.31597 0.663194 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.684 0.663194 15.0104 0.989583C15.3368 1.31597 15.5 1.70833 15.5 2.16667V13.8333C15.5 14.2917 15.3368 14.684 15.0104 15.0104C14.684 15.3368 14.2917 15.5 13.8333 15.5H2.16667ZM2.16667 13.8333H13.8333V2.16667H2.16667V13.8333Z"
        fill="currentColor"
      />
    </g>
  )
});
